import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX } = FiIcons;

const Impressum = ({ onClose }) => {
  return (
    <div className="max-w-3xl relative">
      {onClose && (
        <button 
          onClick={onClose}
          className="mb-8 flex items-center text-azure-600 font-bold hover:text-azure-700 transition-colors"
        >
          <SafeIcon icon={FiX} className="mr-2" /> Fenster schließen
        </button>
      )}
      
      <h2 className="text-3xl font-bold text-black mb-8">Impressum</h2>
      <div className="space-y-6 text-gray-700">
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Angaben gemäß § 5 TMG</h3>
          <p>
            Nadine Rau u. Mike Trepte GbR<br />
            Bettenhäuserstr. 1<br />
            34123 Kassel
          </p>
        </div>
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Vertreten durch</h3>
          <p>
            Geschäftsführer: Nadine Rau, Mike Trepte<br />
            Verantwortlich gem. §10, A3 MDStV: Mike Trepte
          </p>
        </div>
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Kontakt</h3>
          <p>
            Telefon: 0561 / 43027276<br />
            E-Mail: mike.trepte@ki-kundenkommunikation.de
          </p>
        </div>
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Umsatzsteuer-ID</h3>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            DE338605405
          </p>
        </div>
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">
            Berufsbezeichnung und berufsrechtliche Regelungen
          </h3>
          <p>
            Berufsbezeichnung: Unternehmensberatung<br />
            Zuständige Kammer: IHK Kassel-Marburg
          </p>
        </div>
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">Redaktionell verantwortlich</h3>
          <p>
            Mike Trepte<br />
            Bettenhäuserstr. 1<br />
            34123 Kassel
          </p>
        </div>
      </div>

      {onClose && (
        <button 
          onClick={onClose}
          className="mt-12 w-full py-4 bg-gray-100 text-gray-600 font-bold rounded-lg hover:bg-gray-200 transition-colors flex items-center justify-center"
        >
          <SafeIcon icon={FiX} className="mr-2" /> Fenster schließen
        </button>
      )}
    </div>
  );
};

export default Impressum;